const pixTypes = [
    {
        key : 1,
        value : 'CNPJ'
    },
    {
        key : 2,
        value : 'Email'
    },
    {
        key : 3,
        value : 'Telefone'
    },
    {
        key : 4,
        value : 'Chave Aleatória'
    }
]

export default { pixTypes }